import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(authed)/_layout/settings")({
  component: SettingsLayout,
  loader: () => ({ crumb: "Settings" }),
});

function SettingsLayout() {
  return <Outlet />;
}
